module.exports = __webpack_public_path__ + "static/media/regulamento.e3cc3054.pdf";